import { useState } from "react";
import { useMutation } from "@apollo/client";
import { CREATE_USER_V2 } from "../../graphql/mutations/users/createUser.jsx";

export default function CreateUserModal({ onClose }) {
  const [form, setForm] = useState({
    name: "",
    email: "",
    password: "",
    role: "user",
  });

  const [formError, setFormError] = useState("");

  const [createUser, { loading }] = useMutation(CREATE_USER_V2, {
    onCompleted: () => {
      onClose();
    },
    refetchQueries: ["GetUsers"],
  });

  const handleChange = (e) => {
    setForm({
      ...form,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async () => {
    setFormError("");

    try {
      await createUser({
        variables: {
          user: form,
        },
      });
    } catch (err) {
      const gqlErr = err?.graphQLErrors?.[0];
      if (gqlErr) {
        setFormError(gqlErr.message);
      } else {
        setFormError("Unexpected error occurred");
      }
    }
  };

  const isFormInvalid =
    !form.name.trim() || !form.email.trim() || !form.password.trim();

  return (
    <div className="fixed inset-0 bg-black bg-opacity-40 flex justify-center items-center z-50">
      <div className="bg-white rounded-md shadow-lg w-96 p-6 space-y-4 animate-fade-in">
        <h2 className="text-lg font-bold">Create New User</h2>

        {/* Name */}
        <div>
          <label className="font-semibold">Name</label>
          <input
            type="text"
            name="name"
            className="w-full border rounded p-2"
            value={form.name}
            onChange={handleChange}
          />
        </div>

        {/* Email */}
        <div>
          <label className="font-semibold">Email</label>
          <input
            type="email"
            name="email"
            className="w-full border rounded p-2"
            value={form.email}
            onChange={handleChange}
          />
        </div>

        {/* Password */}
        <div>
          <label className="font-semibold">Password</label>
          <input
            type="password"
            name="password"
            className="w-full border rounded p-2"
            value={form.password}
            onChange={handleChange}
          />
        </div>

        {/* Role */}
        <div>
          <label className="font-semibold">Role</label>
          <select
            name="role"
            className="w-full border rounded p-2"
            value={form.role}
            onChange={handleChange}
          >
            <option value="user">User</option>
            <option value="admin">Admin</option>
          </select>
        </div>

        {/* Error */}
        {formError && (
          <p className="text-red-600 font-medium">{formError}</p>
        )}

        {/* Action Buttons */}
        <div className="flex justify-end gap-3">
          <button
            className="px-4 py-2 bg-gray-300 rounded"
            onClick={onClose}
            disabled={loading}
          >
            Cancel
          </button>

          <button
            className="px-4 py-2 bg-primary text-white rounded shadow disabled:opacity-50"
            onClick={handleSubmit}
            disabled={loading || isFormInvalid}
          >
            {loading ? "Saving..." : "Create"}
          </button>
        </div>
      </div>
    </div>
  );
}
